import { render } from "./cardTitle.vue?vue&type=template&id=2171a764&scoped=true"
import script from "./cardTitle.vue?vue&type=script&lang=js"
export * from "./cardTitle.vue?vue&type=script&lang=js"

import "./cardTitle.vue?vue&type=style&index=0&id=2171a764&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2171a764"]])

export default __exports__